import React, { useState } from "react";
import "../index.scss";
import Button from "../../../../../components/common/button";
import { formatAmount } from "../../../../../utils/helper";
import PolicyEraImg from "../../../../../assets/images/image 1 (1).png";
import Card from "../../../../../components/cardView";

const UpgradeCard = ({ orderDetail, handleUpgrade }) => {
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const toggleDetailsVisibility = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };

  const getCoverValue = (orderData) => {
    let cover = 0;
    if (orderData && orderData?.product_variants) {
      orderData.product_variants.map((proData) => {
        let id = proData?.product_id;
        cover = proData?.attribute_map?.cover;
        return formatAmount(cover);
      });
    }
    return formatAmount(cover);
  };

  const headerContent = (
    <>
      {orderDetail.product_variants.map((variant, index) => (
        <img
          key={index}
          src={variant.media_url ? variant.media_url : PolicyEraImg}
          className="product-variant-image"
          alt="Product Variant"
        />
      ))}
    </>
  );

  const bodyContent = (
    <div className="insurance--renewal--order--content">
      <div className="insurance--card--data">
        <div className="card--content--subtitle">Cover</div>
      </div>
      <div className="insurance--card--data">
        <div className="card--content--title">
          {" "}
          {getCoverValue(orderDetail)}
        </div>
      </div>
      <div
        className={`insurance--category ${
          orderDetail.upscale_type === "RECOMMENDED" ? "" : "secondary"
        }`}
      >
        {orderDetail.upscale_type}
      </div>
    </div>
  );

  const footerContent = (
    <div>
      {isDetailsVisible &&
        orderDetail?.product_variants.map((variant, index) => (
          <div
            className="insurance--detail--wrapper"
            key={variant.product_name}
          >
            <div className="details--wrapper--header">
              <div className="details--header--title">
                <h1 className="details--header--title--text">
                  {variant.product_name}
                </h1>
                <h3 className="details--header--subtitle--text">
                  {variant.pspOem.name}
                </h3>
              </div>
              <h3 className="details--header--price">
                {formatAmount(variant.final_premium)}
              </h3>
            </div>
          </div>
        ))}
      <div>
        {orderDetail.upscale_type === "RECOMMENDED" ? (
          <Button
            type="button"
            variant="primary"
            label={`Upgrade ${formatAmount(orderDetail.final_premium)}`}
            onClick={() =>
              handleUpgrade(JSON.stringify(orderDetail.attribute_map))
            }
          />
        ) : (
          <Button
            type="button"
            variant="primaryOutlined"
            label={`Upgrade ${formatAmount(orderDetail.final_premium)}`}
            onClick={() =>
              handleUpgrade(JSON.stringify(orderDetail.attribute_map))
            }
          />
        )}
      </div>
    </div>
  );

  return (
    <Card
      headerContent={headerContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
      isDetailsVisible={isDetailsVisible}
      toggleDetailsVisibility={toggleDetailsVisibility}
    />
  );
};

export default UpgradeCard;
